import { gql } from '@apollo/client';

export const GET_MANUAL_IMPORT_LOGS = gql(/* GraphQL */ `
    query GetManualImportLogs($input: GetImportLogsInput!) {
        getManualImportLogs(input: $input) {
            total
            logs {
                id
                fileName
                s3Key
                importType
                surveyType
                label
                status
                recordsProcessed
                createdAt
                completedAt
                error
                createdBy {
                    id
                    firstName
                    lastName
                }
            }
        }
    }
`);
